import React, { Component } from 'react'
import { connect } from 'react-redux'
import Footer from '../../Components/Footer/Footer'
import HeadingComponent from '../../Components/StudyMaterial/HeadingComponent/HeadingComponent'
import Axios from 'axios'
import NavBar from '../../Components/StudyMaterial/NavBar/NavBar'
import classes from './StudyMaterial.module.css'
import SubjectHeading from '../../Components/StudyMaterial/SubjectHeading/SubjectHeading'
import SyllCollapse from '../../Components/StudyMaterial/Syllabus/Collapse/SyllCollapse'
import MyCollapse from '../../Components/StudyMaterial/Collapse/myCollapse'
import { Modal } from 'antd';

import 'antd/dist/antd.css';

import CircularProgress from '@material-ui/core/CircularProgress';

class StudyMaterial extends Component {
    state = {
        Data: null,
        SubjectHeadingData: null,
        contents: [],
        showSyllabus: false,
        toLogin: false,
        activeKey:null,
        SyllabusData: null,
        loading:true,
        SyllabusError:false,
        SMerror:false,
        syllabusData:null,
        stream:null,
        name:null,
        course:null,
        trial_msg:null
    }
    
    componentWillMount() {
        console.log("Checking Auth")
        console.log(this.props.isAuth)
        if (this.props.Auth) {
            const token = localStorage.getItem('token')
            const name = localStorage.getItem('name')
            const course = localStorage.getItem('course')
            const stream= localStorage.getItem('stream')
            const msg = localStorage.getItem('msg')
           
            console.log("Request Sent")
            console.log(this.props.isAuth)
            Axios.get('http://13.234.61.196:2222/getCourseDetails', { headers: { "authorization": token } })
                .then((res) => {
                    console.log("Data Came")
                    this.setState({ Data: res.data ,loading:false,course:course,stream:stream,trial_msg:msg,name:name,SMerror:false})

                }).catch((e) => {
                    this.setState({ SyllabusError:true,SMerror:true, loading:false})
                })
        }
        else{
            this.setState({loading:false})
        }
    }
    smHandler = ()=>{
        this.setState({ showSyllabus: false })
        // if (this.props.isAuth) {
        //     const token = localStorage.getItem('token')
        //     console.log("Request Sent")
        //     console.log(this.props.isAuth)
        //     Axios.get('http://13.234.61.196:2222/getCourseDetails', { headers: { "authorization": token } })
        //         .then((res) => {
        //             console.log("Data Came")
        //             this.setState({ Data: res.data ,loading:false,SMerror:false})

        //         }).catch((e) => {
        //             this.setState({ SMerror:true ,loading:false,})
        //         })
        // }
        // else{
        //     this.setState({loading:false})
        // }
    }
    syllabusHandler=()=> {
        if (this.props.isAuth) {
                    this.setState({ showSyllabus: true , SyllabusData:this.state.Data.books,loading:false})
        }
    }


    buttonClickHandler(key) {
        console.log(key)
        const data = this.state.Data.books.filter((element) => element.id == key)
        console.log(data[0].contents)
        //Creating a array which contains all the info of content_type
        let contentType = data[0].contents.map((element) => {
            return element.contentList.map(element => {
                return element.content_type
            })

        })
        contentType = contentType.reduce((arr, el) => {
            return arr.concat(el);
        }, [])
        let contents = []

        contentType = contentType.filter((a, b) => contentType.indexOf(a) === b)
        //mapping content_type code with actual content name
        for (let i = 0; i < contentType.length; i++) {
            if (contentType[i] === "1")
                contents.push(" PPT")
            else if (contentType[i] === "2")
                contents.push(" MCQ")
            else if (contentType[i] === "3")
                contents.push(" Question Bank")
            else if (contentType[i] === "4")
                contents.push(" Notes")
            else if (contentType[i] === "5")
                contents.push(" Model Solved Question Paper")

        }
        this.setState({SubjectHeadingData: data[0], contents: contents,activeKey:key })
    }
    handleOk = () => {
        this.props.history.push("/login")
    }
    handleCancel = () => {
        this.props.history.push("/")
    }

    render() {
        console.log(this.stateData)
        let bar = null

        if (this.state.Data !== null) {
          
            bar = (this.state.Data.books.map((element,count) => {
                let value=false
                count++
                if(element.id==this.state.activeKey){
                    value=true
                }
                if(element.subject_name_abbreviation===null){
                    element.subject_name_abbreviation = "SUB "+count;
                   
                }
                return <NavBar active={value} onclick={() => this.buttonClickHandler(element.id)} id={element.id}>{element.subject_name_abbreviation}</NavBar>
            }))
        }
        let syllabusData  = null
        if (this.state.SyllabusData != null) {
           syllabusData =
                this.state.SyllabusData.map((index,count) => {
                    return (<SyllCollapse count = {count}data = {index}/>)
                })
        }

        let subjectHeading = <SubjectHeading contents={this.state.contents} SubjectHeadingData={this.state.SubjectHeadingData} />
        let myCollapse = null
        if (this.state.SubjectHeadingData != null) {
            myCollapse =
                this.state.SubjectHeadingData.contents.map((index) => {
                    return (<MyCollapse data={index} />)
                })
        }
        if (this.state.SubjectHeadingData == null) {
            subjectHeading = null

        }
        let headingComp = null
        if (this.state.Data != null) {
            console.log(this.state.Data)
            headingComp = (<HeadingComponent university={this.state.Data.university} trial_msg={this.state.trial_msg} college={this.state.Data.college} year={this.state.Data.year} stream={this.state.stream} semester={this.state.Data.semester} course={this.state.course} name={this.state.name}/>)
        }
        console.log(this.props)
        let bar2 = null
        let footer = null
        if (this.props.isAuth) {
            let activeSyllabus=false
            let activeSM= false
            if(this.state.showSyllabus){
                activeSyllabus=true
                activeSM=false
            }
            else{
                activeSyllabus=false
                activeSM=true
            }
            bar2 = (<div><NavBar onclick={this.syllabusHandler} active={activeSyllabus} >Syllabus</NavBar>
                <NavBar  onclick={this.smHandler} active={activeSM}>Study Material</NavBar> </div>)
            footer = <Footer />
        }
        let modal = null
        if (!this.props.isAuth) {
            modal = <Modal
                title="Error"
                visible={true}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
            >
                <p>You are not logged in</p>
                <p>press OK to login</p>

            </Modal>
        }
        let  SyllabusCollapse = null
        
         let MainContent = null;
         if(this.state.loading){
            MainContent = <div className={classes.loading}> <CircularProgress /></div>
         }
         else if (!this.state.loading&&!this.state.showSyllabus){
             MainContent  =  (
             <div>
                 {headingComp}
             <div className={classes.NavBarSyllabus}>
                 {bar2}
             </div>
             {this.state.SMerror?<p className={classes.error}>Unable to fetch data</p>:
             <div>
             <div className={classes.NavBar}>{bar}</div>
             {subjectHeading}
             {myCollapse}
             </div>
             }
             
             </div>
             )
         }
         else if (!this.state.loading&&this.state.showSyllabus){
            
            MainContent  =  (
                <div>
                    {headingComp}
                <div className={classes.NavBarSyllabus}>
                    {bar2}
                </div>  
                {syllabusData}
                {this.state.SyllabusError?<p className={classes.error}>Unable to fetch data</p>:SyllabusCollapse}
                </div>
                )
         }
        let bg =null
         if(this.state.showSyllabus){
             bg = {"background-color":"white"}
         }
        return (
         <div className={classes.cont} style ={bg}>
         
         {modal}
        {MainContent}
         {footer}
     </div>
      

        )
    }


}
const mapStateToProps = (state) => {
    return {
        isAuth: state.auth.isAuth,
        Auth:state.auth.token!==null
    }
}
const mapDispatchToProps = (Dispatch) => {
    return {

    }
}
export default connect(mapStateToProps, mapDispatchToProps)(StudyMaterial)
